module.exports = __webpack_public_path__ + "static/img/kpaLogo.5e57b51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/kpaLogo.png
// module id = ncRh
// module chunks = 2